"use strict";
var Observable_1 = require('../../Observable');
var distinctKey_1 = require('../../operator/distinctKey');
Observable_1.Observable.prototype.distinctKey = distinctKey_1.distinctKey;
//# sourceMappingURL=distinctKey.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/distinctKey.js
// module id = 255
// module chunks = 1